import React, { useEffect } from "react";

const CoinCryptoConverter = () => {
  useEffect(() => {
    // Dynamically add the script tag
    const script = document.createElement("script");
    script.src="https://widgets.coingecko.com/gecko-coin-converter-widget.js";
    script.async = true;
    document.body.appendChild(script);

    // Cleanup the script when the component is unmounted
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div>
      <gecko-coin-converter-widget locale="en" transparent-background="true" outlined="true" initial-currency="usd"></gecko-coin-converter-widget>
    </div>
  );
};

export default CoinCryptoConverter;
